module.exports = __webpack_public_path__ + "img/home_img_app@2x.df91f666.png";